import React from "react";
import "./Form.css";
import emailjs from '@emailjs/browser';

function Form() {

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_f2d1oze', 'template_xfeysde', e.target, '1X8se1EdAK6AGYNlH')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
    
    e.target.reset();
  };
  return (
    <form className="main-contact" onSubmit={sendEmail}>
      <div class="container-form">
        <div class="row100">
          <div class="col">
            <div class="inputBox">
              <input type="text" name="from_name" required="required" />
              <span class="text">Name</span>
              <span class="line"></span>
            </div>
          </div>
        </div>
        <div class="row100">
          <div class="col">
            <div class="inputBox">
              <input type="text" name="email" required="required" />
              <span class="text">Email</span>
              <span class="line"></span>
            </div>
          </div>
        </div>
        <div className="row100">
          <div class="col">
            <div class="inputBox">
              <input type="number" name="mobile" required="required" />
              <span class="text">Mobile</span>
              <span class="line"></span>
            </div>
          </div>
        </div>
        <div class="row100">
          <div class="col">
            <div class="inputBox textarea">
              <textarea required="required" name="message"></textarea>
              <span class="text">Type your Message</span>
              <span class="line"></span>
            </div>
          </div>
        </div>
        <div class="row100">
          <div class="col">
            <input type="submit" value="Send" />
          </div>
        </div>
      </div>

      {/* <div>
        <h1 className="h-1">Let's talk.</h1>
        <br />
        <p>
          Get in touch via the form below, or by emailing to{" "}
          <a className="linkm" href="mailto: sharmagauravfeb22@gmail.com">
            sharmagauravfeb22@gmail.com
          </a>
          .
        </p>
      </div>
      <form>
        <div class="form-group">
          <label for="exampleInputPassword1">Name:</label>
          <input
            type="text"
            class="form-control"
            id="exampleInputPassword1"
            placeholder="Password"
          />
        </div>
        <div class="form-group">
          <label for="exampleInputEmail1">Email Address:</label>
          <input
            type="email"
            class="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            placeholder="Enter your name"
          />
        </div>
        <div class="form-group">
          <label for="exampleFormControlTextarea1">Message:</label>
          <textarea
            class="form-control area"
            id="exampleFormControlTextarea1"
            placeholder="Enter your message"
          />
        </div>
        <div class="form-group form-check"></div>
          <button type="submit" class="btn btn-1">
            Submit
          </button>
      </form> */}
    </form>
  );
}

export default Form;
